import type { TicketMessage } from '@/types/ticket'
import dayjs from 'dayjs'

export function SystemMessageRow({ message }: { message: TicketMessage }) {
  return (
    <div className="flex justify-center my-2">
      <div className="text-xs text-muted-foreground bg-muted rounded-full px-3 py-1">
        {message.body} · {dayjs(message.createdAt).format('MMM D, HH:mm')}
      </div>
    </div>
  )
}
